/** UI/UX's numbers and looks: its devices, its accent, a new screen's fill. */

/** A screen's device, by the word `style.device` holds: its size in CSS pixels. */
export const DEVICES: Record<string, { label: string; w: number; h: number }> = {
  phone: { label: "Phone", w: 390, h: 844 },
  tablet: { label: "Tablet", w: 820, h: 1180 },
  desktop: { label: "Desktop", w: 1440, h: 1024 },
  watch: { label: "Watch", w: 198, h: 242 },
};

/** The device a frame made by a click is. */
export const FIRST_DEVICE = "phone";

/** The accent a new button takes. */
export const ACCENT = "#6a4be0";

/** A new screen's fill. */
export const SCREEN_FILL = "#ffffff";

/** An input's fill, outline and words when its style says none. */
export const INPUT_LOOK = { fill: "#ffffff", stroke: "#c9c6d6", color: "#1f1d2b" } as const;

/** The words' size of UI/UX's elements when their style says none (CSS pixels). */
export const ELEMENT_WORDS_PX = 15;

/** How far beside its component a new instance goes (board units). */
export const INSTANCE_GAP = 40;

/** How deep instances inside components are drawn (a component holding itself stops there). */
export const INSTANCE_DEPTH = 3;

/** The largest gap and padding offered (board units). */
export const SPACING_MAX = 400;
